import React from 'react';
import { Box, IconButton } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from 'react-router-dom';

const QuizHomeButton: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 24,
        left: 24,
        zIndex: 10,
      }}
    >
      <IconButton
        onClick={() => navigate('/')}
        sx={{
          background: '#e3f0fd',
          color: '#1976d2',
          borderRadius: '50%',
          boxShadow: 2,
          width: 40,
          height: 40,
          border: '2px solid #90caf9',
          '&:hover': {
            background: '#bbdefb',
          },
          p: 0,
        }}
        aria-label="Home"
      >
        <HomeIcon fontSize="medium" />
      </IconButton>
    </Box>
  );
};

export default QuizHomeButton;